module.exports = __webpack_public_path__ + "img/barrelhouse-radio.67b0d554.png";